import { countries } from './countries';

export interface RegionsResponse {
	regions: Record<string, { name: string; provinces: Record<string, string> }>;
}

export async function fetchCountryRegions(country: string): Promise<
	| {
			code: string;
			name: string;
			provinces: { code: string; name: string }[];
	  }[]
	| undefined
> {
	const result = countries.find((c) => c.country === country);
	if (result?.url)
		return ((await fetch(result.url)).json() as Promise<RegionsResponse>).then((data) =>
			Object.entries(data.regions)
				.map(([code, { name, provinces }]) => ({
					code,
					name,
					provinces: Object.entries(provinces)
						.map(([code, name]) => ({ code, name }))
						.toSorted((a, b) => a.name.localeCompare(b.name)),
				}))
				.toSorted((a, b) => a.name.localeCompare(b.name)),
		);
}
